import React from 'react'
import { isEmptyString } from 'util/isEmptyString'
import { ListicleContent } from './ListicleContent'

export const OrderedListicleContents = ({
  step,
  item,
  voteButtonComponent,
}) => {
  // Puck-authored items deliver pre-rendered React nodes per layout region
  // instead of a `listicleContents` array. Drop them straight into the same
  // row/column structure so the existing listicle.scss layout applies.
  if (item.puckRows) {
    const { top, middleLeft, middleRight, bottom } = item.puckRows
    const hasMiddle = Boolean(middleLeft || middleRight)
    return (
      <div className="listicle-item-contents">
        {top && <div className="row row-top">{top}</div>}
        {hasMiddle && (
          <div className="row row-middle">
            <div className="col col-left">{middleLeft}</div>
            <div className="col col-right">{middleRight}</div>
          </div>
        )}
        {bottom && <div className="row row-bottom">{bottom}</div>}
        {item.hasVoting && (
          <div className="row row-voting">{voteButtonComponent}</div>
        )}
      </div>
    )
  }

  let listicleContents = item.listicleContents

  // Legacy content won't have layout settings for us to use.
  // if there's an image, we can leverage that to determine layout.
  // otherwise, everything will get stacked in the BOTTOM row.
  const legacyImageWithNoLayout = listicleContents.findIndex(current => {
    return current?.type === 'Image' && isEmptyString(current.layoutRow)
  })

  // If we have an image and no layout info, use the image to determine layout
  if (legacyImageWithNoLayout != -1) {
    const useMiddleRow =
      listicleContents.find(
        element =>
          element?.type === 'Image' && element.imageType !== 'HORIZONTAL',
      ) != -1

    if (useMiddleRow) {
      listicleContents.forEach((current, i, arr) => {
        if (current?.type === 'Image') {
          if (isEmptyString(item.layoutRow)) {
            arr[i].layoutRow = 'MIDDLE'
            arr[i].layoutColumn = 'LEFT'
          }
        } else {
          if (isEmptyString(item.layoutRow)) {
            arr[i].layoutRow = 'MIDDLE'
            arr[i].layoutColumn = 'RIGHT'
          }
        }
      })
    }
  }

  // Listicle images in beaker have a property called imageType that can affect layout.
  // Get the imageType so we can later append it to .row-middle
  const extraCss = listicleContents.reduce((accumulator, current) => {
    if (current?.type === 'Image') {
      return accumulator + ' ' + current.imageType
    }
    return accumulator
  }, '')

  // Separate listicleContents into their respective rows.
  // We reduce the array of listicleContents into an object with 3 keys, TOP, MIDDLE, BOTTOM.
  // Each key points to an array of content items.
  const validLayoutRows = ['TOP', 'MIDDLE', 'BOTTOM']

  const orderedContents = listicleContents.reduce(
    (current, item, i) => {
      // content may not have a definition
      if (!validLayoutRows.includes(item.layoutRow)) {
        item.layoutRow = 'BOTTOM'
      }

      current[item.layoutRow].push(item)

      return current
    },
    {
      TOP: [],
      MIDDLE: [],
      BOTTOM: [],
    },
  )

  // console.log(orderedContents)

  return (
    <div className={`listicle-item-contents`}>
      {orderedContents['TOP'].length > 0 && (
        <div className="row row-top">
          {orderedContents['TOP'].map((content, i) => {
            return <ListicleContent step={step} content={content} key={i} />
          })}
        </div>
      )}
      {orderedContents['MIDDLE'].length > 0 && (
        <div className={`row row-middle ${extraCss}`}>
          <div className="col col-left">
            {orderedContents['MIDDLE'].map((content, i) => {
              if (content.layoutColumn === 'LEFT') {
                return <ListicleContent step={step} content={content} key={i} />
              }
            })}
          </div>
          <div className="col col-right">
            {orderedContents['MIDDLE'].map((content, i) => {
              if (content.layoutColumn !== 'LEFT') {
                return <ListicleContent step={step} content={content} key={i} />
              }
            })}
          </div>
        </div>
      )}
      {orderedContents['BOTTOM'].length > 0 && (
        <div className="row row-bottom">
          {orderedContents['BOTTOM'].map((content, i) => {
            return <ListicleContent step={step} content={content} key={i} />
          })}
        </div>
      )}
      {item.hasVoting && (
        <div className="row row-voting">{voteButtonComponent}</div>
      )}
    </div>
  )
}
